<script lang="ts">
	import { Button } from '$lib/shadcn/components/ui/button';
	import type { FileDropZoneRootProps } from '$lib/shadcn/components/ui/file-drop-zone';
	import * as FileDropZone from '$lib/shadcn/components/ui/file-drop-zone';
	import { X } from '@lucide/svelte';
	import _ from 'lodash';
	import HydrationFallback from './HydrationFallback.svelte';
	import { Skeleton } from '$lib/shadcn/components/ui/skeleton';

	let {
		acceptedFileTypes,
		files = $bindable([]),
		disabled,
		...restProps
	}: { acceptedFileTypes: Array<string>; files: Array<File> } & Omit<
		FileDropZoneRootProps,
		'onUpload' | 'accept'
	> = $props();
</script>

<HydrationFallback>
	{#snippet skeleton()}
		<Skeleton class="flex h-30 items-center justify-center border border-dashed"
			>Loading...</Skeleton
		>
		<div></div>
	{/snippet}
	<FileDropZone.Root
		accept={acceptedFileTypes.join()}
		onUpload={async (local_files) => {
			files.push(...local_files);
		}}
		{disabled}
		{...restProps}
	>
		<FileDropZone.Trigger
			class=" not-aria-disabled:hover:preset-tonal h-30 not-aria-disabled:cursor-pointer aria-disabled:opacity-50"
			><div class="flex h-full items-center justify-center rounded border border-dashed">
				<p>Select file or drag here</p>
			</div></FileDropZone.Trigger
		>
		<div aria-disabled={disabled} class="flex flex-col gap-1 aria-disabled:opacity-50">
			{#each files as file}
				<div
					class="text-muted-foreground preset-tonal flex items-center justify-between rounded p-1 px-2 text-sm"
				>
					<div class="flex items-center gap-2">
						<p class="">{file.name}</p>
						<p class="text-muted-foreground-3 text-xs">{FileDropZone.displaySize(file.size)}</p>
					</div>
					<Button
						size="icon-xs"
						variant="ghost-destructive"
						onclick={() => _.remove(files, (x) => x == file)}><X /></Button
					>
				</div>
			{/each}
		</div>
	</FileDropZone.Root>
</HydrationFallback>
